export default class FinesseFooter extends HTMLElement {
  constructor() {
    super()
  }
}

customElements.define('finesse-footer', FinesseFooter)
